module.exports = __webpack_public_path__ + "img/despacho.5c35c906.svg";